export function bisectRight(sortedValues: readonly number[], value: number) {
	let low = 0;
	let high = sortedValues.length;

	while (low < high) {
		const middle = low + Math.floor((high - low) / 2);
		if (value < sortedValues[middle]) high = middle;
		else low = middle + 1;
	}

	return low;
}
